module.exports = __webpack_public_path__ + "img/child-bg.1bf69942.png";